export default __webpack_public_path__ + "static/media/four.d0403344.png";